import {useParams} from "react-router";

import {IRankingAnnualParams, IRankingParams, rpAppLink} from "@pg-mono/rp-routes";

import {IBreadcrumb} from "../../app/components/breadcrumbs/IBreadcrumb";
import {useGetRegionDetailListBySlugQuery} from "../../region/api/get_region_detail_list_by_slug";

export const useOfferRankingListBreadcrumbs = (): IBreadcrumb[] => {
    const params = useParams<IRankingParams & Partial<Pick<IRankingAnnualParams, "year">>>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: params.citySlug});
    const region = data?.results[0];

    if (!region) {
        return [];
    }

    return [
        {
            key: "ranking-inwestycji",
            name: "Ranking Inwestycji",
            position: "2",
            url: rpAppLink.ranking.base()
        },
        {
            key: region.name,
            name: region.name,
            position: "3",
            url: !params.year
                ? rpAppLink.ranking.lastYearList({citySlug: region.slug})
                : rpAppLink.ranking.annualList({
                      year: params.year.toString(),
                      citySlug: region.slug
                  })
        }
    ];
};
